import * as StateLib from "@/Utils/StateLib";
import { Fragment } from "react";
import { Icon, Menu, ToolIcon, TooltipWrapper } from "@theorgchartdev/storybook";
import { getHoverTipContent } from "@/Utils/Misc";
import { appstr } from "@coreapp/utils/appstr";
import { editModeTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";

const ChartToolsComposite = () => {
  let wsMgr = StateLib.GetWSMgr();
  const isPosition = wsMgr?.GetDoc().IsPositionDocument();

  const AddSub = (isAssistant = false) => {
    wsMgr.SetToolMode("ToolMode6", true);
  };

  const AddAssistant = () => {
    wsMgr.SetToolMode("ToolMode7", true);
  };

  const MoveBox = () => {
    wsMgr.SetToolMode("ToolMode5", true);
  };

  const AddHolder = () => {
    wsMgr.SetToolMode("ToolMode17", true);
  };

  const DeleteBox = () => {
    wsMgr.fCanvasPanel.DeleteSelection();
    StateLib.ReRenderCanvas();
  };

  let firstSelectedBox = wsMgr.GetFirstSelectedBox(true);

  const getAddSubInput = () => {
    if (isPosition) {
      return (
        <Menu
          dataTestId={editModeTestId("add-subordinate-menu")}
          buttonSize={"small"}
          label={
            <TooltipWrapper tooltipProps={getHoverTipContent("addsubtoolpos")}>
              <Icon name="square-plus" id="ctb-addsub-btn" size="small" />
            </TooltipWrapper>
          }
          options={[
            {
              content: appstr("Add subordinate position(s)"),
              icon: "cubes",
              value: "add-sub",
              clickHandler: AddSub
            },
            {
              content: appstr("Add employee(s) to position"),
              icon: "user-plus",
              value: "add-holder",
              clickHandler: AddHolder
            }
          ]}
        />
      );
    } else {
      return (
        <ToolIcon
          id={"ctb-addbox-btn"}
          name={"square-plus"}
          title={appstr("addsubtool")}
          onClick={AddSub}
          tooltipProps={getHoverTipContent("addsubtool")}
          dataTestId={editModeTestId("add-subordinate-btn")}
        />
      );
    }
  };

  return (
    <Fragment>
      {getAddSubInput()}
      <ToolIcon
        id={"ctb-delbox-btn"}
        name={"square-delete"}
        title={appstr("Remove box")}
        disabled={firstSelectedBox == null}
        onClick={DeleteBox}
        tooltipProps={getHoverTipContent(isPosition ? "Delete box (positions)" : "Delete box")}
        dataTestId={editModeTestId("delete-box-btn")}
      />
      <ToolIcon
        name={"square-arrows"}
        title={appstr("moveboxtool")}
        onClick={MoveBox}
        tooltipProps={getHoverTipContent("moveboxtool")}
        dataTestId={editModeTestId("move-box-btn")}
      />
      {!isPosition && (
        <ToolIcon
          name={"plus-dotted_"}
          title={appstr("addassist")}
          onClick={AddAssistant}
          tooltipProps={getHoverTipContent("addassisttool")}
          dataTestId={editModeTestId("add-assistant-btn")}
        />
      )}
    </Fragment>
  );
};

export default ChartToolsComposite;
